import styled from 'styled-components';
import { SingleSelectMenu } from '../../../../components/Dropdown';

export const JoinConditionDimSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const JoinConditionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  gap: 4px;
  padding-bottom: 12px;
`;

export const JoinConditionRow = styled.div<{
  $isHeader?: boolean;
  $isLast?: boolean;
}>`
  display: grid;
  grid-template-columns: 100px 240px 170px auto;
  grid-gap: 4px;
  margin-bottom: ${({ $isHeader, $isLast }) =>
    $isHeader ? '6px' : $isLast ? 0 : '8px'};
`;

export const JoinSqlConditionRow = styled.div`
  display: grid;
  grid-template-columns: 138px 624px;
  align-items: center;
`;

export const JoinConditionCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledJoinTypeSelect = styled(SingleSelectMenu)`
  width: 100px;
`;

export const StyledTemporalJoinTypeSelect = styled(SingleSelectMenu)`
  width: 170px;
`;

export const StyledJoinConditionOperatorSelect = styled(SingleSelectMenu)`
  width: 170px;
`;

export const CenteredDiv = styled.div`
  margin: auto;
`;
